'use strict';

const DEFAULT_NAMESPACE = "default";
const ANNOTATION_VIEW_URL = "backstage.io/view-url";
const ANNOTATION_EDIT_URL = "backstage.io/edit-url";
const ANNOTATION_KUBERNETES_API_SERVER = "kubernetes.io/api-server";
const ANNOTATION_KUBERNETES_API_SERVER_CA = "kubernetes.io/api-server-certificate-authority";
const ANNOTATION_KUBERNETES_AUTH_PROVIDER = "kubernetes.io/auth-provider";

exports.ANNOTATION_EDIT_URL = ANNOTATION_EDIT_URL;
exports.ANNOTATION_KUBERNETES_API_SERVER = ANNOTATION_KUBERNETES_API_SERVER;
exports.ANNOTATION_KUBERNETES_API_SERVER_CA = ANNOTATION_KUBERNETES_API_SERVER_CA;
exports.ANNOTATION_KUBERNETES_AUTH_PROVIDER = ANNOTATION_KUBERNETES_AUTH_PROVIDER;
exports.ANNOTATION_VIEW_URL = ANNOTATION_VIEW_URL;
exports.DEFAULT_NAMESPACE = DEFAULT_NAMESPACE;
//# sourceMappingURL=constants.cjs.js.map
